import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Navigation from './navigation';
import Footer from './footer';
import VideoPlayer from './VideoPlayer';
import { fetchVideo } from './api';

const VideoDetail = () => {
  const { id } = useParams();
  const [video, setVideo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const v = await fetchVideo(id);
        if (mounted) setVideo(v);
      } catch (e) {
        setError('Failed to load video');
      } finally {
        if (mounted) setLoading(false);
      }
    };
    load();
    return () => { mounted = false; };
  }, [id]);

  return (
    <div>
          <div className="fixed top-0 left-0 right-0 z-50">
  <Navigation />
</div>
      <div className="hero-section2">
        <div className="page-title">Video</div>
      </div>

      <div className="max-width" style={{ padding: '24px 0' }}>
        {loading ? (
          <div>Loading video...</div>
        ) : error ? (
          <div style={{ color: 'red' }}>{error}</div>
        ) : video ? (
          <div style={{ maxWidth: 960, margin: '0 auto' }}>
            <VideoPlayer video={video} autoPlay={true} linkToDetail={false} />
            <div style={{ marginTop: 12 }}>
              <h2 style={{ margin: 0 }}>{video.title}</h2>
              {video.category && <div style={{ color: '#666' }}>{video.category}</div>}
            </div>
          </div>
        ) : (
          <div>Video not found</div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default VideoDetail;
